import React from "react";
import { X } from "lucide-react";
import api, { resolveImg } from "../../../../lib/api";
import { logger } from "../../../../lib/logger";
import { toast } from "sonner";
import { inp, lbl } from "../../shared";

const isVideo = (url) => /\.(mp4|webm|mov)(\?|$)/i.test(url);

const HeroThumb = ({ url, onRemove, testId }) => (
  <div className="relative w-28 h-18 bg-[#151515] border border-[#262421] overflow-hidden">
    {isVideo(url)
      ? <video src={resolveImg(url)} muted className="w-full h-full object-cover" style={{ height: 72 }} />
      : <img src={resolveImg(url)} alt="" className="w-full h-full object-cover" style={{ height: 72 }} />}
    <button onClick={onRemove} className="absolute -top-2 -end-2 bg-[#c88] text-[#0B0A08] w-5 h-5 flex items-center justify-center" data-testid={testId}><X size={12} /></button>
  </div>
);

const SecondsInput = ({ label, value, onChange, testId, placeholder }) => (
  <div className="flex items-center gap-2">
    <label className={lbl + " !mb-0"}>{label}</label>
    <input type="number" min="2" max="120" value={value ?? ""} onChange={(e) => onChange(e.target.value === "" ? null : parseInt(e.target.value, 10))} data-testid={testId} placeholder={placeholder} className={inp + " w-20 !mt-0"} />
  </div>
);

export const HeroMedia = ({ settings, setSettings, patch, uploading, onUpload, onRemove, heroUrl, setHeroUrl }) => {
  const addUrl = async () => {
    const u = heroUrl.trim();
    if (!u) return;
    const list = [...(settings.hero_images || []), u];
    const next = { ...settings, hero_images: list, hero_image: list[0] };
    setSettings(next);
    try {
      await api.put("/settings", next);
      setHeroUrl("");
      toast.success("Added");
    } catch (e) {
      logger.error("hero url save failed", e);
      toast.error("Failed to save");
    }
  };

  return (
    <div className="pt-6 border-t border-[#262421]">
      <label className={lbl}>Homepage Hero — Images & Videos (rotate automatically)</label>
      <div className="flex flex-wrap items-center gap-3 mt-2">
        {(settings.hero_images || []).map((img, i) => <HeroThumb key={img} url={img} onRemove={() => onRemove(i)} testId={`hero-remove-${i}`} />)}
        <label className="cursor-pointer border border-dashed border-[#262421] px-5 py-6 text-xs uppercase tracking-widest hover:border-[#C49A6C] transition-colors" data-testid="hero-upload">
          {uploading ? "…" : "+ Add"}
          <input type="file" accept="image/*,video/*" className="hidden" onChange={onUpload} />
        </label>
      </div>
      <p className="text-[10px] text-[#6E685F] mt-2">Add several images or videos — they fade and rotate on the homepage. First item shows first.</p>
      <div className="flex items-center gap-2 mt-3">
        <input value={heroUrl} onChange={(e) => setHeroUrl(e.target.value)} placeholder="أو الصق رابط صورة/فيديو · or paste an image/video URL" data-testid="hero-url-input" className={inp + " flex-1 !mt-0"} />
        <button data-testid="hero-url-add" onClick={addUrl} className="border border-[#C49A6C] text-[#C49A6C] text-[10px] uppercase tracking-widest px-4 py-2.5 hover:bg-[#C49A6C] hover:text-[#0B0A08] transition-colors whitespace-nowrap">+ Add URL</button>
      </div>
      <div className="flex flex-wrap items-center gap-5 mt-4">
        <SecondsInput label="مدة الفيديو · Video (s)" value={settings.hero_video_seconds} onChange={(v) => patch("hero_video_seconds", v)} testId="hero-video-seconds" placeholder="9" />
        <SecondsInput label="مدة الصورة · Image (s)" value={settings.hero_image_seconds} onChange={(v) => patch("hero_image_seconds", v)} testId="hero-image-seconds" placeholder="6" />
      </div>
    </div>
  );
};
